// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__HbcJT","featuredResort":"styles_featuredResort__ip4Mq","snowflake":"styles_snowflake__TchvA","content":"styles_content__GMuRH"};